
import { generateAsyncSagaWatcher } from '../../../utils';
import { IContactDetailsRs } from '../models';
import { EContactActions } from './enums';

export const configurationsSaga = generateAsyncSagaWatcher<IContactDetailsRs>(EContactActions.GET_CONFIG);

export const sendMessageSaga = generateAsyncSagaWatcher<void>(EContactActions.SEND_MESSAGE);
